import { useInitializeSession } from './useInitializeSession';

import { ResetPasswordDocument } from '@graphql/generated/graphql';

import { useMutation, useReactiveVar } from '@apollo/client';
import { sessionProcessingVar } from '@boot/reactiveVariables';

export const usePasswordReset = () => {
    const [resetPassword, { error, reset }] = useMutation(
        ResetPasswordDocument,
        {
            context: {
                notifyOnError: true,
            },
            notifyOnNetworkStatusChange: true,
            onError: () => {},
        },
    );
    const { initializeSession } = useInitializeSession(resetPassword, true);
    const loginProcessing = useReactiveVar(sessionProcessingVar);

    return {
        cancelReset: reset,
        handleReset: initializeSession,
        resetError: error,
        resetProcessing: loginProcessing,
    };
};
